import { Chip, Skeleton, Stack } from '@mui/material';
import React from 'react';
import ShowContainer from '../../components/material-ui/ShowContainer';
import { IconLock } from '@tabler/icons-react';
import styled from '@emotion/styled';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view';
import { useAppSelector } from '../../store';
import CusThreeItem from './CusThreeItem';

const GroupChildren = ({
  gamerCount,
  groupName,
  isLocked,
  isGame,
  groupId,
  parentId = null,
  setClickedGroupId,
  setChooseGroupeId,
  isHighlight,
  casinoId,
  viewId
}) => {
  const childrenGroup = useAppSelector((state) => state.user.group.children);
  const childrenCurrentGroup = childrenGroup?.[groupId];

  const withoutCasino = !casinoId;

  return (
    <CusThreeItem
      gamerCount={gamerCount}
      groupId={groupId}
      parentId={parentId}
      viewId={viewId}
      groupName={groupName}
      isLocked={isLocked}
      setChooseGroupeId={setChooseGroupeId}
      setClickedGroupId={setClickedGroupId}
      key={groupId}
      isHighlight={isGame && isHighlight && withoutCasino}
      children={
        !isGame ? (
          <ShowContainer
            condition={childrenCurrentGroup}
            plug={<Skeleton variant="text" width={210} height={60} />}>
            {childrenCurrentGroup?.map((child) => {
              const childId = parentId ? `${parentId}-${child.groupId}` : String(child.groupId);

              return (
                <GroupChildren
                  group={child}
                  parentId={groupId}
                  key={childId}
                  viewId={viewId}
                  setClickedGroupId={setClickedGroupId}
                  setChooseGroupeId={setChooseGroupeId}
                  gamerCount={child.gamerCount}
                  groupId={child.groupId}
                  isLocked={child.locked}
                  groupName={child.name}
                  isGame={child.game}
                  isHighlight={isHighlight}
                  casinoId={child.casinoId}
                />
              );
            })}
          </ShowContainer>
        ) : null
      }
    />
  );
};

export default GroupChildren;
